<template>
  <div class="container-large">
    <div id="tosola-concept" class="card card-container col gap-4">
      <div class="row">
        <h2 class="bottom-line">How to play</h2>
      </div>
      <div class="row gap-3 reverse">
        <div class="basis-70-gap-3">
          <video class="card" autoplay muted loop>
            <source src="../../assets/img/landing-pages/tosola/TOSOLA_comic.webm" type="video/webm" />
          </video>
        </div>
        <div class="basis-30-gap-3">
          <h3>Read the comic</h3>
          <p>Start by reading the first comic panels to understand what’s going on! You’ll get slowly introduced to the world and the gameplay.</p>
          <p class="note">NOTE:<br>The comic book is non-linear. As you make progress and learn more about the town and its inhabitants, you will be instructed to read new comic entries.</p>
        </div>
      </div>
      <div class="row gap-3">
        <div class="basis-30-gap-3">
          <h3>Talk with characters and gather clues</h3>
          <p>Ask the townsfolk what they know about the mysterious events unfolding in Tosola, seek their knowledge to understand clues or help them accomplish their dreams.</p>
          <p>Collecting clues and talking with characters unlocks new topics to explore.</p>
        </div>
        <div class="basis-70-gap-3">
          <video class="card" autoplay muted loop>
            <source src="../../assets/img/landing-pages/tosola/TOSOLA_deduction.webm" type="video/webm" />
          </video>
        </div>
      </div>
      <div class="row gap-3 reverse">
        <div class="basis-70-gap-3">
          <video class="card" autoplay muted loop>
            <source src="../../assets/img/landing-pages/tosola/TOSOLA_app.webm" type="video/webm" />
          </video>
        </div>
        <div class="basis-30-gap-3">
          <h3>Solve puzzles using your deduction skills</h3>
          <p>Use the clues you’ve gathered to identify mushrooms, find flowers you need and piece together what is really going on in Tosola.</p>
          <p class="note">NOTE:<br>Some clue cards have to be used with the comic book to advance the story, through Hidden Number puzzles.</p>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: "TosolaConcept",
  methods: {
    resizeHandler() {
      this.isMobile = window.innerWidth < 1024;
    }
  },
  created() {
    this.isMobile = window.innerWidth < 1024;
    window.addEventListener("resize", this.resizeHandler);
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

#tosola-concept {
  background-color: $tosola-dark-green;

  h2, h3 {
    color: $tosola-light-green;
  }

  p {
    color: $cream;
  }

  h2.bottom-line {
    border-bottom: 1px solid $tosola-light-green;
    margin-bottom: 0px;
  }
}

video.card {
  height: auto;
  width: 100%;
  border-radius: 20px;
}

@media only screen and (max-width: 1024px) {
  .basis-60-gap-3, .basis-40-gap-3 {
    flex-basis: unset;
  }

  .app-icon {
    max-width: 100px;
  }
}

</style>